import axios from "axios";
import { getBaseUrlParams } from "../../utils/getBaseUrlParams";

const { organization_id, short_url } = getBaseUrlParams();

const instance = axios.create({
  baseURL: `/organizations/${organization_id}/custom_graphs`
});

const withParams = (params = {}) => ({ params: { ...params, short_url } });

export const api = {
  createModule: (data) => instance.post("", data, withParams()),
  getModules: (params) => instance.get("", withParams(params)),
  changeModulePosition: (id, direction, params) =>
    instance.put(`/${id}/${direction}`, null, withParams(params)),
  editModule: (id, data) => instance.put(`/${id}`, data, withParams()),
  getPreview: (id, params) => instance.get(`/${id}/edit`, withParams(params)),
  getPreviewChart: (params) => instance.get("/preview", withParams(params)),
  getCategoryList: () => instance.get("/category_list", withParams()),
  deleteModule: (id, params) => instance.delete(`/${id}`, withParams(params))
};
